<template>
  <div class="container">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="8">
        <a-form-item label="站点名称">
          <a-input
            placeholder="请输入站点名称"
            v-decorator="['station_name']"
          />
        </a-form-item>
        <a-form-item label="任务类型">
          <a-select
            v-decorator="['task_type_id', { initialValue: 0 }]"
            placeholder="请选择任务类型"
            style="width: 200px;"
          >
            <a-select-option
              v-for="item in taskTypeOptions"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="运维人员">
          <a-select
            v-decorator="['ops_user_id']"
            placeholder="请选择运维人员"
            style="width: 200px;"
            option-filter-prop="children"
            showSearch
          >
            <a-select-option
              v-for="item in operationUserList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选择日期">
          <a-range-picker
            v-decorator="[
              'time_range',
              {
                initialValue: [
                  moment().subtract(30, 'days'),
                  moment()
                    .add(1, 'days')
                    .startOf('day')
                ]
              }
            ]"
            :allowClear="false"
            style="width: 320px"
            format="YYYY-MM-DD HH:mm"
            :show-time="{ format: 'HH: mm' }"
          />
        </a-form-item>
        <a-form-item label="任务状态">
          <a-select
            v-decorator="['task_status', { initialValue: '全部' }]"
            placeholder="请选择任务状态"
            style="width: 180px;"
          >
            <a-select-option
              v-for="item in statusOptions"
              :key="item.type"
              :value="item.type"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-row>
      <div style="text-align: right;margin: 8px 16px">
        <a-form-item>
          <a-button type="primary" html-type="submit" style="margin-right: 8px">
            查询
          </a-button>
          <a-button @click="resetForm">
            重置
          </a-button>
        </a-form-item>
      </div>
    </a-form>
    <a-button
      type="primary"
      icon="plus"
      style="margin-bottom:20px"
      @click="
        visible = true;
        action = 'add';
      "
      >新建任务</a-button
    >
    <div>
      <a-table
        :columns="columns"
        :data-source="taskList"
        rowKey="id"
        :pagination="{
          current: page,
          total: total,
          pageSize: size,
          onChange: onPageChange
        }"
      >
        <template slot="idx" slot-scope="text, record, index">
          {{ (page - 1) * size + index + 1 }}
        </template>
        <template slot="ops_user" slot-scope="text, record">
          {{ record.ops_user | opsUsersFormat }}
        </template>
        <template slot="task_status" slot-scope="text">
          <a-badge
            :status="text == 0 ? 'processing' : 'success'"
            :text="text == 0 ? '进行中' : '已完成'"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="addLog(record)">添加日志</a>
          <a-divider type="vertical" v-show="record.task_status == 1" />
          <a @click="viewDetail(record)" v-show="record.task_status == 1"
            >查看详情</a
          >
        </template>
      </a-table>
    </div>
    <add-or-edit-task
      :visible.sync="visible"
      :action="action"
      :record="record"
      @onOk="
        v => {
          visible = v;
          getTaskList();
        }
      "
    ></add-or-edit-task>
    <task-detail
      :detailVisible.sync="detailVisible"
      :record="record"
    ></task-detail>
    <add-task-log
      :logVisible.sync="logVisible"
      :record="record"
      @onOk="
        v => {
          logVisible = v;
          getTaskList();
        }
      "
    ></add-task-log>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import AddOrEditTask from "./components/AddOrEditTask";
import TaskDetail from "./components/TaskDetail";
import AddTaskLog from "./components/AddTaskLog";
import { getTaskList } from "@/api/api";
import { task_list_columns } from "@/options/columns";
import moment from "moment";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns: task_list_columns,
      taskTypeOptions: [],
      taskList: [],
      statusOptions: [
        { type: "全部", name: "全部" },
        { type: 0, name: "进行中" },
        { type: 1, name: "已完成" }
      ],
      visible: false,
      action: "",
      record: {},
      page: 1,
      size: 10,
      total: 0,
      detailVisible: false,
      logVisible: false
    };
  },
  components: {
    AddOrEditTask,
    TaskDetail,
    AddTaskLog
  },
  computed: {
    ...mapState(["authUserInfo", "taskTypeList", "operationUserList"]),
    ...mapGetters(["defaultInfo"])
  },
  watch: {
    taskTypeList() {
      this.taskTypeOptions = this.$_.cloneDeep(this.taskTypeList);
      this.taskTypeOptions.unshift({ id: 0, name: "全部" });
    }
  },
  filters: {
    opsUsersFormat(v) {
      if (v && v.length) {
        return v.map(item => item.name).join(", ");
      }
      return "";
    }
  },
  mounted() {
    this.getStationList();
    this.getTaskTypeList();
    this.getTaskList();
  },
  methods: {
    moment,
    ...mapActions(["getStationList", "getTaskTypeList"]),
    async getTaskList() {
      try {
        const fieldsValue = this.form.getFieldsValue();
        let station_name = fieldsValue.station_name ?? "";
        let task_type_id = fieldsValue.task_type_id;
        let ops_user_id = fieldsValue.ops_user_id;
        let start_time = moment(fieldsValue.time_range[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let end_time = moment(fieldsValue.time_range[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let task_status = fieldsValue.task_status;
        let res = await getTaskList(
          this.defaultInfo.defaultGroupId,
          this.page,
          this.size,
          station_name,
          task_type_id,
          ops_user_id,
          start_time,
          end_time,
          task_status
        );
        this.taskList = res.data.items;
        this.total = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          await this.getTaskList();
        }
      });
    },
    resetForm() {
      this.form.resetFields();
      const form_ = {
        task_type_id: 0,
        time_range: [moment().subtract(10, "days"), moment()],
        task_status: "全部"
      };
      this.form.setFieldsValue(form_);
      this.getTaskList();
    },
    addLog(record) {
      this.record = record;
      this.logVisible = true;
    },
    onPageChange(v) {
      this.page = v;
      this.getTaskList();
    },
    viewDetail(record) {
      this.record = record;
      this.detailVisible = true;
    }
  }
};
</script>

<style scoped>
.container {
  padding: 10px;
}
</style>
